function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanknoteAlternative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9 19C6.19108 19 4.78661 19 3.77772 18.3259C3.34096 18.034 2.96596 17.659 2.67412 17.2223C2 16.2134 2 14.8089 2 12C2 9.19108 2 7.78661 2.67412 6.77772C2.96596 6.34096 3.34096 5.96596 3.77772 5.67412C4.78661 5 6.19108 5 9 5L15 5C17.8089 5 19.2134 5 20.2223 5.67412C20.659 5.96596 21.034 6.34096 21.3259 6.77772C22 7.78661 22 9.19108 22 12C22 14.8089 22 16.2134 21.3259 17.2223C21.034 17.659 20.659 18.034 20.2223 18.3259C19.2134 19 17.8089 19 15 19H9Z",
    strokeWidth: 1.5,
    style: {
      stroke: "var(--mui-palette-icon-schiefer, #475467)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9 9C7.34315 9 6 10.3431 6 12C6 13.6569 7.34315 15 9 15",
    strokeWidth: 1.5,
    style: {
      stroke: "var(--mui-palette-icon-schiefer, #475467)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15 9C16.6569 9 18 10.3431 18 12C18 13.6569 16.6569 15 15 15",
    strokeWidth: 1.5,
    style: {
      stroke: "var(--mui-palette-icon-schiefer, #475467)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5V18.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    style: {
      stroke: "var(--mui-palette-icon-schiefer, #475467)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5V18.5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    style: {
      stroke: "var(--mui-palette-icon-schiefer, #475467)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanknoteAlternative);
export default __webpack_public_path__ + "static/media/BanknoteAlternative.6519e5682f94110585cefdd4b49a51bc.svg";
export { ForwardRef as ReactComponent };